module.exports = __webpack_public_path__ + "img/portraits_22_V.dcbbd762.webp";